import { setupWorker } from 'msw/browser';
import { handlers } from './handlers';

export const mocksServer = setupWorker(...handlers);
